/*
 * Four algorithmic systems currently in operation at Gemeente Leeuwarden.
 * Each system is mapped against the VNG lifecycle with narrative, risk class,
 * legal basis, and the public-value it serves.
 */

import { Wallet, HandCoins, HeartPulse, Scale } from "lucide-react";

export const leeuwardenSystems = [
  {
    id: "uitkeringscheck",
    code: "LWD-01",
    name: "Uitkeringscheck",
    tagline: "Participatiewet • bijstand",
    icon: Wallet,
    riskClass: "Hoog risico",
    lifecycleStage: "Monitoring",
    legalBasis: "Participatiewet art. 53a · AVG art. 6 lid 1 sub e",
    narrative:
      "Uitkeringscheck ondersteunt klantmanagers bij de rechtmatigheids­toets van bijstands­uitkeringen. Het systeem signaleert patronen die op een wijziging in de leefsituatie kunnen duiden. Een signaal is nooit een besluit: elke casus wordt door een medewerker beoordeeld, en de burger heeft recht op uitleg en bezwaar. Binnen RiskaiΛ loopt dit systeem continu door een fairness-audit langs leeftijd, wijk en gezinssamenstelling.",
    publicValue:
      "Gelijke behandeling van bijstandsgerechtigden en voorkomen dat rechtmatige ondersteuning onterecht wordt stopgezet.",
    safeguards: ["Human-in-the-loop", "Fairness-audit per kwartaal", "Geregistreerd in Algoritmeregister"],
  },
  {
    id: "schuldhulpverlening",
    code: "LWD-02",
    name: "Vroegsignalering Schulden",
    tagline: "Wet gemeentelijke schuldhulpverlening",
    icon: HandCoins,
    riskClass: "Midden risico",
    lifecycleStage: "Validatie",
    legalBasis: "Wgs art. 3 · convenanten met woningcorporaties & energieleveranciers",
    narrative:
      "Op basis van betalings­achterstanden bij vaste lasten­partners benadert de gemeente inwoners vroegtijdig met een hulpaanbod. Het model prioriteert huishoudens waar de stapeling van signalen wijst op beginnende problematische schulden. RiskaiΛ toetst dat het model niet onevenredig aanbelt bij bepaalde wijken of achtergrond­kenmerken en dat elke inwoner zelf kan beslissen om het aanbod te weigeren.",
    publicValue:
      "Voorkomen dat schulden escaleren naar huisuitzetting of afsluiting — met respect voor autonomie van de inwoner.",
    safeguards: ["Opt-out recht", "Proportionaliteits­toets", "Menselijke benadering door buurtteam"],
  },
  {
    id: "wmo-zorg",
    code: "LWD-03",
    name: "WMO Zorgtoewijzing",
    tagline: "Wet maatschappelijke ondersteuning",
    icon: HeartPulse,
    riskClass: "Hoog risico",
    lifecycleStage: "Ontwikkeling",
    legalBasis: "WMO 2015 art. 2.3.5 · AVG art. 9 (bijzondere gegevens)",
    narrative:
      "Een beslissings­ondersteunend systeem helpt WMO-consulenten om passende ondersteuning te bepalen bij huishoudelijke hulp, dagbesteding en begeleiding. Omdat het systeem werkt met gezondheidsgegevens geldt het hoogste beschermings­regime. RiskaiΛ bewaakt dat indicaties alleen adviserend zijn, en dat een consulent altijd kan afwijken met onderbouwing.",
    publicValue:
      "Maatwerk in zorg: de juiste ondersteuning voor de inwoner, zonder dat statistiek de menselijke maat vervangt.",
    safeguards: ["Advies, geen besluit", "Afwijkplicht met motivatie", "DPIA vernieuwd per jaar"],
  },
  {
    id: "handhaving",
    code: "LWD-04",
    name: "Handhaving Openbare Ruimte",
    tagline: "APV · Omgevingswet",
    icon: Scale,
    riskClass: "Midden risico",
    lifecycleStage: "Implementatie",
    legalBasis: "Gemeentewet art. 149 · APV Leeuwarden · Omgevingswet",
    narrative:
      "Boa's en handhavers krijgen via dit systeem een dagplanning voor surveillance: waar zijn meldingen, waar staan evenementen, waar verwachten we overlast. Het model gebruikt géén persoons­gegevens maar geaggregeerde meldingen en openbare data. RiskaiΛ bewaakt dat bepaalde wijken niet structureel oververtegenwoordigd raken in patrouilles — een expliciet risico van predictive policing.",
    publicValue:
      "Efficiënte inzet van schaarse handhavings­capaciteit zonder wijk­stigmatisering.",
    safeguards: ["Geen persoonsgegevens", "Wijk-evenwichts­indicator", "Publieke verantwoording per kwartaal"],
  },
];
